import { apiClient } from './client';

export const staffApi = {
  getAll: (params) => apiClient.get('/staff', { params }),
  getActive: (params) => apiClient.get('/staff/active', { params }),
  getById: (id) => apiClient.get(`/staff/${id}`),
  create: (data) => apiClient.post('/staff', data),
  update: (id, data) => apiClient.put(`/staff/${id}`, data),
  delete: (id) => apiClient.delete(`/staff/${id}`),
  assignLogin: (id, data) => apiClient.post(`/staff/${id}/assign-login`, data),
};
